/**
 * Application Routes
 * 
 * Centralized route definitions to avoid magic strings.
 * Use these constants instead of hardcoding route paths.
 * 
 * @example
 * import { ROUTES } from '@/constants/routes';
 * navigate(ROUTES.DASHBOARD);
 */

export const ROUTES = {
  // Public routes
  LOGIN: '/login',
  ACTIVATE: '/auth/activate',
  /** Login-free public mini-app forms: /forms/:formSlug/:token */
  PUBLIC_FORMS_BASE: '/forms',

  // Protected routes
  DASHBOARD: '/dashboard',
  UNAUTHORIZED: '/unauthorized',
  
  // Catch-all
  HOME: '/',
} as const;

// Type for route values
export type Route = typeof ROUTES[keyof typeof ROUTES];

